import { setContext } from 'apollo-link-context';
import { merge } from 'lodash-es';

import { getCurrentUserSession } from 'remote/auth';
import { isSSOAuthenticated } from 'utils/okta-sso';

export const withAuthToken = setContext(async (_, previousContext) => {
  let token: string | null = null;

  if (isSSOAuthenticated()) {
    token = sessionStorage.getItem('sso_id_token');
  } else {
    const session = await getCurrentUserSession();
    if (session) {
      token = session.getIdToken().getJwtToken();
    }
  }

  if (!token) {
    return previousContext;
  }

  return merge({ headers: { authorization: `Bearer ${token}` } }, previousContext);
});
